export default __webpack_public_path__ + "static/media/eta-lang.f7363774.svg";